import { Controller } from "@hotwired/stimulus";
import { Chart } from "chart.js/auto";

export default class extends Controller {
  static targets = ["canvas"];
  static values = {
    type: String,
    data: Array,
    prefix: { type: String, default: "" },
  };

  connect() {
    if (this.hasCanvasTarget) {
      this.createChart();
    }
  }

  createChart() {
    const ctx = this.canvasTarget.getContext("2d");
    const type = this.typeValue;
    const data = this.dataValue;
    const prefix = this.prefixValue;

    const isDark = document.documentElement.classList.contains("dark");
    const gridColor = isDark ? "rgba(255, 255, 255, 0.05)" : "rgba(0, 0, 0, 0.05)";
    const textColor = isDark ? "#94a3b8" : "#64748b"; // slate-400 / slate-500
    const primaryColor = "#8b5cf6"; // purple-500
    
    // Create gradient for line charts
    let gradient = ctx.createLinearGradient(0, 0, 0, 300);
    gradient.addColorStop(0, "rgba(139, 92, 246, 0.5)"); // purple-500 w/ opacity
    gradient.addColorStop(1, "rgba(139, 92, 246, 0.0)");

    const isLine = type === "line";

    let chartData = {
      labels: data.map((d) => d.x),
      datasets: [
        {
          label: "Value",
          data: data.map((d) => d.y),
          backgroundColor: isLine ? gradient : primaryColor,
          borderColor: isLine ? primaryColor : "transparent",
          borderWidth: isLine ? 3 : 0,
          tension: 0.4, // smooth curves
          fill: isLine,
          pointRadius: 0,
          pointHoverRadius: 6,
          pointBackgroundColor: primaryColor,
          borderRadius: isLine ? 0 : 4, // rounded bars
          barThickness: isLine ? undefined : 16,
        },
      ],
    };

    new Chart(ctx, {
      type: type === "column" ? "bar" : type,
      data: chartData,
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: { display: false },
          tooltip: {
            backgroundColor: isDark ? "#1e293b" : "#ffffff",
            titleColor: isDark ? "#f8fafc" : "#0f172a",
            bodyColor: isDark ? "#cbd5e1" : "#475569",
            borderColor: isDark ? "rgba(255,255,255,0.1)" : "rgba(0,0,0,0.1)",
            borderWidth: 1,
            padding: 12,
            boxPadding: 4,
            callbacks: {
              label: (context) => `${prefix}${context.formattedValue}`,
            },
          },
        },
        scales: {
          x: {
            grid: { display: false, drawBorder: false },
            ticks: { color: textColor, font: { family: "'Inter', sans-serif" } },
          },
          y: {
            grid: { color: gridColor, drawBorder: false },
            ticks: { color: textColor, font: { family: "'Inter', sans-serif" }, maxTicksLimit: 5 },
            beginAtZero: true,
          },
        },
        interaction: {
          intersect: false,
          mode: "index",
        },
      },
    });
  }
}
